import "./SearchComponent.scss";
import {useCallback, useEffect, useState} from "react";
import InputComponent from "../core/input/InputComponent";
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import IconButtonComponent from "../core/icon-button/IconButtonComponent";
interface SearchComponentProps {
    id?: string;
    label: string;
    size?: 'small' | 'medium';
    placeholder?: string;
    value?: string;
    onChange?: (value: any) => void;
    disabled?: boolean;
}

const SearchComponent = (props: SearchComponentProps) => {

    const {label, disabled, onChange, ...otherProps} = props;
    const [searchText, setSearchText] = useState<string | undefined>(props.value);
    const placeholder = props.placeholder || label;
    const size = props.size || 'small';

    useEffect(() => {
        setSearchText(props.value);
    }, [props.value]);

    const handleSearchTextChange = useCallback((value: any) => {
        if (onChange) {
            onChange(value);
        }
        setSearchText(value);
    }, [onChange]);

    const handleSearchClear = useCallback(() => {
        handleSearchTextChange("");
    }, [handleSearchTextChange]);

    return (
        <div className={'search-component'}>
            <InputComponent
                name="search"
                label={label}
                value={searchText}
                onChange={handleSearchTextChange}
                size={size}
                fullWidth={true}
                disabled={disabled}
                placeholder={placeholder}
                suffix={
                    <>
                        {searchText?.length === 0 && <IconButtonComponent
                            size={"small"}
                            position={"end"}>
                            <SearchIcon/>
                        </IconButtonComponent>
                        }
                        {(searchText && searchText.length > 0) && <IconButtonComponent
                            size={"small"}
                            position={"end"}
                            onClick={handleSearchClear}>
                            <ClearIcon/>
                        </IconButtonComponent>
                        }
                    </>
                }
                {...otherProps}
            />
        </div>
    );

};

export default SearchComponent;
